import { render, staticRenderFns } from "./specialinformation.vue?vue&type=template&id=21d9fb51&scoped=true"
import script from "./specialinformation.vue?vue&type=script&lang=js"
export * from "./specialinformation.vue?vue&type=script&lang=js"
import style0 from "./specialinformation.vue?vue&type=style&index=0&id=21d9fb51&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d9fb51",
  null
  
)

export default component.exports